import rsApiRequestV3 from "@services/rsApiRequestV3";
import { GetAllConnectionRequest, GetAllConnectionResult } from "./dto";

const getAll = (params: GetAllConnectionRequest): Promise<GetAllConnectionResult> =>
  rsApiRequestV3.post('app/connection.getall', params)

export default {
  getAll
}